import { render, staticRenderFns } from "./lawCard.vue?vue&type=template&id=0525ac52&"
import script from "./lawCard.vue?vue&type=script&lang=js&"
export * from "./lawCard.vue?vue&type=script&lang=js&"
import style0 from "./lawCard.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports